import CryptoJS from "crypto-js";
import { currencyConstants } from "../constants";

export const updateObject = (oldObject, updatedProperties) => ({
  ...oldObject,
  ...updatedProperties,
});

export const encryptData = (data, secretKey) => {
  // Ensure the secret key is properly formatted as UTF-8 and has the correct length
  const key = CryptoJS.enc.Utf8.parse(secretKey);

  // Encrypt the data
  const encrypted = CryptoJS.AES.encrypt(JSON.stringify(data), key, {
    mode: CryptoJS.mode.ECB, // You might also want to specify encryption mode
    padding: CryptoJS.pad.Pkcs7, // Use PKCS7 padding
  });

  // Return the encrypted data as a string
  return encrypted.toString();
};

export const formatNumber = (amount) => {
  const num = parseFloat(amount);
  if (isNaN(num)) {
    return "";
  }
  return num.toFixed(2);
};

export const formatDate = (dateStr) => {
  const date = new Date(dateStr);
  if (isNaN(date)) return ""; // invalid date check

  const day = date.getUTCDate();
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const month = monthNames[date.getUTCMonth()];
  const year = date.getUTCFullYear();

  // Function to get ordinal suffix for day
  function getOrdinal(n) {
    if (n > 3 && n < 21) return "th";
    switch (n % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  }

  return `${day}${getOrdinal(day)} ${month} ${year}`;
};

// Replace the _ with space
export const formatWithSpaces = (text = "") => {
  if (typeof text !== "string") {
    return "";
  }
  return text.replace(/_/g, " ");
};

// Check the match string is include or not in the str
export const containsString = (str, match) => {
  if (typeof str !== "string" || typeof match !== "string") {
    return false; // or handle this case as needed
  }
  return str.toLowerCase().includes(match.toLowerCase());
};

export const isExactMatch = (str, match) => {
  if (typeof str !== "string" || typeof match !== "string") {
    return false;
  }
  return str.toLowerCase() === match.toLowerCase();
};

export const getCurrencyCode = (currencyCode) => {
  return currencyCode === currencyConstants.CAD
    ? currencyConstants.CANADIAN_DOLLAR
    : currencyConstants.DOLLAR;
};
